export default "__VITE_ASSET__DcnEWDvJ__"